import { Chart, PolarAreaController, RadialLinearScale, } from 'chart.js';
import { merge } from 'chart.js/helpers';
import { calculatePolarScale } from './utils';
import { getMinMax, parseErrorNumberData } from './base';
import { generateTooltipPolar } from './tooltip';
import { animationHints } from '../animate';
import { ArcWithErrorBar } from '../elements';
import patchController from './patchController';
export class PolarAreaWithErrorBarsController extends PolarAreaController {
    getMinMaxImpl(scale) {
        const t = this._cachedMeta;
        const e = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY,
        };
        t.data.forEach((_, i) => {
            const s = this.getParsed(i)[scale.axis];
            if (Number.isNaN(s) || !this.chart.getDataVisibility(i)) {
                return;
            }
            if (s < e.min) {
                e.min = s;
            }
            if (s > e.max) {
                e.max = s;
            }
        });
        return e;
    }
    getMinMax(scale) {
        return getMinMax(scale, (patchedScale) => this.getMinMaxImpl(patchedScale));
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        return meta.data.reduce((acc, _, index) => {
            if (!Number.isNaN(meta._parsed[index].r) && this.chart.getDataVisibility(index)) {
                return acc + 1;
            }
            return acc;
        }, 0);
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        this.parseErrorData(parsed, meta, data, start, count);
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        this.parseErrorData(parsed, meta, data, start, count);
        return parsed;
    }
    parseErrorData(parsed, meta, data, start, count) {
        const scale = meta.rScale;
        for (let i = 0; i < count; i += 1) {
            const index = i + start;
            const item = data[index];
            const v = scale.parse(item[scale.axis], index);
            parsed[i] = {
                [scale.axis]: v,
            };
        }
        parseErrorNumberData(parsed, scale, data, start, count);
    }
    updateElement(element, index, properties, mode) {
        if (typeof index === 'number') {
            calculatePolarScale(properties, this.getParsed(index), this._cachedMeta.rScale, mode === 'reset', this.chart.options);
        }
        super.updateElement(element, index, properties, mode);
    }
    updateElements(arcs, start, count, mode) {
        const scale = this.chart.scales.r;
        const bak = scale.getDistanceFromCenterForValue;
        scale.getDistanceFromCenterForValue = function getDistanceFromCenterForValue(v) {
            if (typeof v === 'number') {
                return bak.call(this, v);
            }
            return bak.call(this, v.r);
        };
        super.updateElements(arcs, start, count, mode);
        scale.getDistanceFromCenterForValue = bak;
    }
}
PolarAreaWithErrorBarsController.id = 'polarAreaWithErrorBars';
PolarAreaWithErrorBarsController.defaults = merge({}, [
    PolarAreaController.defaults,
    animationHints,
    {
        dataElementType: ArcWithErrorBar.id,
    },
]);
PolarAreaWithErrorBarsController.overrides = merge({}, [
    PolarAreaController.overrides,
    {
        plugins: {
            tooltip: {
                callbacks: {
                    label: generateTooltipPolar,
                },
            },
        },
    },
]);
PolarAreaWithErrorBarsController.defaultRoutes = PolarAreaController.defaultRoutes;
export class PolarAreaWithErrorBarsChart extends Chart {
    constructor(item, config) {
        super(item, patchController('polarAreaWithErrorBars', config, PolarAreaWithErrorBarsController, ArcWithErrorBar, [
            RadialLinearScale,
        ]));
    }
}
PolarAreaWithErrorBarsChart.id = PolarAreaWithErrorBarsController.id;
//# sourceMappingURL=PolarAreaWithErrorBarsController.js.map